<template>
  <div class="tHPayWithdrawContainerParentDiv">
    <div
        style="display: flex; flex-direction: row; align-items: center; justify-content: space-between"
    >
      <div style="display: flex; flex-direction: row; align-items: center">
        <div class="shuLine" />
        <div :style="hcf.getTextStyle({ addSize: 1 })">{{ title }}</div>
      </div>

      <div class="parsed-desc">
        <template v-for="(part, index) in parsedDesc" :key="index">
          <span v-if="part.type === 'text'">{{ part.content }}</span>
          <button
              v-else
              class="desc-button"
              :style="{
                backgroundColor:getEachContainerBgColor(false),
                color:'var(--ct-main-color)',
              }"
              @click="openLink(part.url)"
          >
            {{ part.title }}
          </button>
        </template>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup>
  import { computed } from "vue";
  import { hcf } from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const props = defineProps({
    title: String,
    desc: String,
  });

  // 解析带按钮的字符串 desc
  const parsedDesc = computed(() => {
    const input = props.desc || "";
    const regex = /\[(.*?)\]/g;
    let match;
    let lastIndex = 0;
    const result = [];

    while ((match = regex.exec(input)) !== null) {
      if (match.index > lastIndex) {
        result.push({
          type: "text",
          content: input.substring(lastIndex, match.index),
        });
      }

      const inside = match[1];
      const [title, url] = inside.split("|");
      if (title && url) {
        result.push({
          type: "button",
          title: title.trim(),
          url: url.trim(),
        });
      }

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < input.length) {
      result.push({
        type: "text",
        content: input.substring(lastIndex),
      });
    }

    return result;
  });
  function getEachContainerBgColor(isSelect){
    if(HNewGameUIConfig.newGameUIType === 3){
      if(isSelect){
        return "#3F362E";
      }else{
        return "#191B15";
      }
    }else{
      return "#f7f7f7";
    }
  }
  function openLink(url) {
    window.open(url, "_blank");
  }
</script>

<style scoped>
  .shuLine {
    margin-right: 5px;
    width: 3px;
    height: 13px;
    border-radius: 10px;
    background-color: var(--ct-main-color);
  }

  .tHPayWithdrawContainerParentDiv {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: var(--ct-main-container-bg-color);
    margin: 10px;
    border-radius: 10px;
  }

  /* 按钮解析样式 */
  .parsed-desc {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    color: #777;
    font-size: 13px;
  }

  .desc-button {
    border: none;
    border-radius: 6px;
    padding: 2px 5px;
    cursor: pointer;
    font-size: 12px;
    margin-left: 6px;
  }
</style>
